import { Directive, ElementRef, HostBinding, HostListener, Inject, Input } from '@angular/core';
import { Router } from '@angular/router';
import { BASE_URL } from '../../misselaineous/boot.tokens';
​
​
@Directive({
    selector: '[routerLink]',
})
export class RouterLink {
    base: URL;
​
    @HostBinding('attr.role') role: string;
    @Input() @HostBinding('attr.target') target: string;
    @Input() @HostBinding('attr.href') routerLink: string;
​
​
    constructor(
        private router: Router,
        @Inject(BASE_URL)
        private base_url,
        elm: ElementRef
    ) {
        this.base = new URL(this.base_url);
        this.role = (elm.nativeElement as HTMLElement).tagName === 'A' ? null : "link"
    }
​
    @HostListener('click', ['$event']) onClick(e: Event) {
        e.preventDefault();
        e.cancelBubble = true;
        const url = new URL(this.routerLink, this.base_url)
        if ((this.target != null && this.target != '_self') || (url?.origin !== this.base?.origin)) {
            window.open(url, this.target);
            return;
        } else
            this.router.navigateByUrl(url.href.replace(url?.origin, ''));
        setTimeout(() => {
            if (url.hash.length > 0)
                document.getElementById(url.hash).scrollIntoView();
        }, 750);
    }
​
}
​
export { RouterLink as RouterLinkWithHref }
